<template>
    <div class="public_container personnel_add_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

            </ReturnNavBar>
        </div>
        <div class="user_info_box">
            <div class="img_box">
                <img :src="userDetails.header_img ? userDetails.header_img : defaultImg" loading="lazy" alt="" />
            </div>
            <div class="user_info_middle">
                <p>
                    <span class="ellipsis">{{ userDetails.name }}</span>
                    <template>
                        <span class="tag_status tag_status_danger" v-if="userDetails.quit_status === 0">待离职</span>
                        <span class="tag_status tag_status_warning" v-if="userDetails.entry_status == 1">待入职</span>
                        <span class="tag_status tag_status_success" v-if="profile_edit">待确定</span>
                        <span
                            class="tag_status tag_status_warning2"
                            v-if="userDetails.is_active == 0 && userDetails.entry_status == 0"
                            >未注册</span
                        >
                    </template>
                </p>
                <p>{{ userDetails.did_name || "--" }}</p>
            </div>
        </div>
        <!-- "entry_status": 0, '邀请入职状态 0=正常 1=待入职', -->
        <!-- "quit_status": 0,  '离职状态 0=待离职 1=已离职 2=已取消', -->
        <p v-if="userDetails.entry_status === 1" class="tip_text">
            该员工已填写入职信息，请核实无误后，操作【确认入职】加入公司
        </p>
        <p v-else-if="userDetails.quit_status === 0" class="tip_text">
            该员工已办理离职，请确认工作交接后，操作确认离职
        </p>
        <p v-else-if="userDetails.is_active == 0 && userDetails.entry_status == 0" class="tip_text">
            该员工未注册澜精灵账号，请发送登录链接给员工，您也可以<van-button
                class="link_text"
                :disabled="isSendSms"
                @click="handleClickSend"
                >发送短信</van-button
            >通知对方
        </p>
        <div class="mobile_container">
            <CustomFormMobile
                ref="personnel_custom_form"
                :is_form_module="true"
                :is_preview_mode="formPreviewMode"
                :field_list="formInfoList"
                :form_detail="formData"
                :pk_id="userId"
                @submit-form="submitFormData"
                v-if="dataLoaded"
            />
        </div>
        <!-- 单选弹框 -->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="showRadioPicker"
            :show="showRadioPicker"
        >
            <div class="radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in operatorList"
                        class="radio_option_item"
                        @click="handleClickRadioOption(item)"
                        v-text="item.title"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="showRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickOperator">操作</van-button>
        </div>
    </div>
</template>

<script>
import { Dialog } from "vant";
import {
    getFormFields,
    getUserDetail,
    editUser,
    confirmEntry,
    cancelEntry,
    SendLoginSMS,
    UpdateProfileEdit,
    GetUserProfileEdits,
    ConfirmProfileEdit,
} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "MPersonnelDetail",
    components: { ReturnNavBar, CustomFormMobile },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            formPreviewMode: true, // 是否为预览模式
            userStatus: "", // 员工类型
            userId: "", // 用户id
            profile_edit: "", // 用来判断信息确认
            edit_id: "", // 用于信息编辑时候传的参数
            userDetails: {
                header_img: "",
                name: "",
                did_name: "",
                entry_status: "",
                is_active: "",
            },
            loading: false,
            formData: {},
            formInfoList: [],
            dataLoaded: false,
            btnDisabled: false,
            operatorOptions: {
                // unRegist: [
                //     { type: "edit", title: "信息编辑" },
                //     { type: "changeDepartment", title: "变更部门" },
                //     { type: "cancelAdd", title: "取消添加" },
                // ], // 未注册
                // formal: [
                //     { type: "edit", title: "信息编辑" },
                //     { type: "changeDepartment", title: "变更部门" },
                //     { type: "leaveOffice", title: "办理离职" },
                //     // { type: "invit", title: "邀请完善信息" },
                // ], // 正常
                // leave: [{ type: "editLeaveOfficeInfo", title: "修改离职信息" }], // 已离职
                // pendingEmployment: [
                //     { type: "confirmEmployment", title: "确定入职" },
                //     { type: "cancelEmployment", title: "取消入职" },
                //     { type: "edit", title: "信息编辑" },
                // ], // 待入职
                // pendingLeave: [
                //     { type: "confirmLeave", title: "确定离职" },
                //     { type: "cancelLeave", title: "取消离职" },
                //     { type: "editleaveInfo", title: "修改离职信息" },
                // ], // 待离职
                // pendingConfirm: [
                //     { type: "confirmInfo", title: "信息确认" },
                //     { type: "edit", title: "信息编辑" },
                //     { type: "leaveOffice", title: "办理离职" },
                // ], // 待确定

                // is_active 是否激活 0=否 1=是
                // entry_status 邀请入职状态 0=正常 1=待入职
                // 1. 如果是未激活 和 邀请入职状态不是待入职 ，说明是直接新增的，用户没有登录，此时可以取消，可以取消添加
                // 2. 如果是未激活 和 邀请入职状态是待入职 , 说明是直接走的邀请，此时可以取消，可以确认入职,确认的时候改为已激活状态
                // 3. 如果是已激活 和 邀请入职状态不是待入职。 说明走的直接新增，并且已经登陆了，此时不可以取消，应该是已经入职了
                // 4. 如果是已激活 和 邀请入职状态是待入职。 说明走的邀请，并且无法登录已经登陆了，这种状态为错误数据
                is_active: {
                    0: [
                        { type: "edit", title: "信息编辑" },
                    ],
                    1: [
                        { type: "edit", title: "信息编辑" },
                    ],
                },
                entry_status: {
                    0: [],
                    1: [
                        { type: "confirmEmployment", title: "确定入职" },
                        { type: "cancelEmployment", title: "取消入职" },
                    ],
                },
            },
            operatorList: [], // 操作列表
            showRadioPicker: false,
            isSendSms: false, // 是否发送了短信 每次只能发送一次，再次进来这个页面还可以操作，避免无限点击
        };
    },
    created() {
        if (this.$route.query) {
            this.userId = Number(this.$route.query.uid);
            this.profile_edit = this.$route.query.profile_edit || false;
        }
        this._getFromFields();
    },
    methods: {
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "users",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    if (this.userId) {
                        if (this.profile_edit) {
                            // 被邀请之后 编辑过的
                            GetUserProfileEdits({
                                user_id: this.userId,
                            }).then((res) => {
                                if (res.code === 200) {
                                    // edit_id编辑的时候用
                                    this.edit_id = res.data.id;
                                    // 如果编辑过 就用最新编辑的数据，否则使用最开始的数据
                                    let data = res.data.edited_data ? res.data.edited_data : res.data.original_data;
                                    this.formData = data;
                                    this.userDetails.header_img = data.avatar;
                                    this.userDetails.name = data.name.value;
                                    this.userDetails.did_name =
                                        data.department_id.text && data.department_id.text.length
                                            ? data.department_id.text[0].full_path
                                            : "";
                                    this.userDetails.entry_status = 0;
                                    this.userDetails.is_active = 1;
                                    this.loading = false;
                                    this.dataLoaded = true;
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                        } else {
                            getUserDetail({
                                user_id: this.userId,
                            })
                                .then((res) => {
                                    if (res.code === 200) {
                                        this.formData = res.data;
                                        this.userDetails.header_img = res.data.avatar;
                                        this.userDetails.name = res.data.name.value;
                                        this.userDetails.did_name =
                                            res.data.department_id.text && res.data.department_id.text.length
                                                ? res.data.department_id.text[0].full_path
                                                : "";
                                        this.userDetails.entry_status = res.data.entry_status;
                                        this.userDetails.is_active = res.data.is_active;
                                        this.loading = false;
                                        this.dataLoaded = true;
                                    } else {
                                        this.$toast({
                                            message: res.message,
                                            type: "fail",
                                        });
                                    }
                                })
                                .catch(() => {});
                        }
                    }
                }
            });
        },
        // 发送短信，只能发送一次，下次进来页面还可发送
        handleClickSend() {
            SendLoginSMS({ user_id: this.userId }).then((res) => {
                if (res.code === 200) {
                    this.$toast({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.isSendSms = true;
                        },
                    });
                }
            });
        },
        handleClickOperator() {
            const is_active = this.userDetails.is_active;
            const entry_status = this.userDetails.entry_status;
            // 根据状态获取可操作选项
            let operatorList = [];
            const is_active_list = this.operatorOptions.is_active[is_active];
            const entry_status_list = this.operatorOptions.entry_status[entry_status];
            operatorList = [...entry_status_list, ...is_active_list];

            if (is_active == 1 && entry_status == 0) {
                // 正常员工
                if(!this.profile_edit) {
                    operatorList.push({ type: "changeDepartment", title: "变更部门" })
                }
                operatorList.push({ type: "leaveOffice", title: "办理离职" } );
                if(!this.profile_edit) {
                    operatorList.push({ type: "invit", title: "邀请完善信息" })
                }
            }
            if(is_active == 0 && entry_status == 0) {
                operatorList.push({ type: "cancelAdd", title: "取消添加" })
            }
            // if (is_active == 0 && entry_status == 1) {
            //     operatorList.push({ type: "confirmInfo", title: "信息确认" });
            // }
            if(this.profile_edit) {
                // 邀请之后 编辑过的
                operatorList.unshift({ type: "confirmInfo", title: "信息确认" })
            }
            this.operatorList = operatorList;
            this.showRadioPicker = true;
        },
        handleClickRadioOption(item) {
            switch (item.type) {
                case "edit":
                    // 编辑
                    this.$router.push({
                        name: "MPersonnelEdit",
                        query: {
                            uid: this.userId,
                        },
                    });
                    this.showRadioPicker = false;
                    break;
                case "changeDepartment":
                    // 变更部门
                    this.$router.push({
                        name: "MPersonnelDepartmentChange",
                        query: {
                            user_ids: [this.userId],
                        },
                    });
                    break;
                case "leaveOffice":
                    // 办理离职
                    this.$router.push({
                        name: "MLeaveOffice",
                        query: {
                            uid: this.userId,
                        },
                    });
                    break;
                case "confirmEmployment":
                    // 确定入职
                    Dialog.confirm({
                        title: "确定入职",
                        message: "确定入职后，该员工加入公司，账号立即生效！",
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            const params = {
                                user_id: this.userId,
                            };
                            confirmEntry(params).then((res) => {
                                if (res.code === 200) {
                                    this.$toast({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.$router.go(-1);
                                        },
                                    });
                                }
                            });
                        })
                        .catch(() => {});
                    break;
                case "cancelEmployment":
                    // 取消入职
                    Dialog.confirm({
                        title: "取消入职",
                        message: "取消入职后，如需再次加入公司需要重新邀请或新增员工。",
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            const params = {
                                user_id: this.userId,
                            };
                            cancelEntry(params).then((res) => {
                                if (res.code === 200) {
                                    this.$toast({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.$router.go(-1);
                                        },
                                    });
                                }
                            });
                        })
                        .catch(() => {});
                    break;
                case "cancelAdd":
                    // 取消添加
                    Dialog.confirm({
                        title: "取消添加",
                        message: "取消添加后，如需再次加入公司需要重新邀请或新增员工。",
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            const params = {
                                user_id: this.userId,
                            };
                            cancelEntry(params).then((res) => {
                                if (res.code === 200) {
                                    this.$toast({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.$router.go(-1);
                                        },
                                    });
                                }
                            });
                        })
                        .catch(() => {});
                    break;
                case "confirmInfo":
                    // 信息确认
                    ConfirmProfileEdit({ user_id: this.userId }).then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.go(-1);
                                },
                            });
                        }
                    });
                case "invit":
                    // 邀请完善信息

            }
        },
        submitFormData(customForm) {},
    },
};
</script>

<style lang="scss" scoped>
.personnel_add_wrap {
    .user_info_box {
        height: 68px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        gap: 8px;
        background-color: #ffffff;
        .img_box {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            flex-shrink: 0;
            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .user_info_middle {
            flex: 1;
            overflow: hidden;
            p {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
            }
            p:nth-child(1) {
                font-weight: 700;
                color: rgba(51, 51, 51, 1);
            }
            p:nth-child(2) {
                color: rgba(102, 102, 102, 1);
            }
            .tag_status {
                margin-left: 8px;
                flex-shrink: 0;
                height: 18px;
                padding: 0 4px;
                border-radius: 5px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                &.tag_status_warning {
                    background-color: rgba(240, 170, 50, 0.15);
                    color: rgba(240, 170, 50, 1);
                }
                &.tag_status_success {
                    background-color: rgba(90, 179, 51, 0.15);
                    color: rgba(90, 179, 51, 1);
                }
                &.tag_status_danger {
                    background-color: rgba(228, 65, 68, 0.15);
                    color: rgba(228, 65, 68, 1);
                }
                &.tag_status_primary {
                    background-color: rgba(41, 144, 240, 0.15);
                    color: rgba(41, 144, 240, 1);
                }
                &.tag_status_warning2 {
                    background-color: rgba(255, 141, 26, 0.15);
                    color: rgba(255, 141, 26, 1);
                }
            }
        }
    }
    .tip_text {
        padding: 2px 16px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        .link_text {
            vertical-align: top;
            height: 22px;
            color: rgba(41, 144, 255, 1);
            border: 0;
            padding: 0;
        }
    }
    .mobile_container {
        padding: 10px 0;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
.radio_option_wrap {
    width: 100%;
    height: 100%;
    padding: 0 16px 35px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .radio_option_list {
        border-radius: 8px;
        max-height: calc(100% - 90px);
        overflow-y: auto;

        .radio_option_item {
            background-color: #ffffff;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-bottom: 1px solid #dedede;

            &:first-child {
                border-radius: 8px 8px 0 0;
            }

            &:last-child {
                border-bottom: none;
                border-radius: 0 0 8px 8px;
            }
        }
    }

    .cancel_btn {
        background-color: #ffffff;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding: 10px 0;
        color: #666666;
        border-radius: 8px;
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
        margin-top: 10px;
    }
}
</style>
